import React from 'react';
import { ctaMicrocopy, hero } from '../data/content';
import { CtaButton } from './CtaButton';
import { ImageSlot } from './ImageSlot';
type HeroProps = {
  heroMockupUrl: string;
};
export function Hero({
  heroMockupUrl
}: HeroProps) {
  return <section id="hero" aria-labelledby="hero-title" className="relative overflow-hidden bg-white" data-id="element-93" data-mp="9l33na9io82x">
      {/* Decorative color shapes (desktop only, left side, behind the text; the mockup has a white background) */}
      <span aria-hidden="true" className="pointer-events-none absolute -left-28 -top-28 hidden h-72 w-72 rounded-full bg-sun/25 xl:block" data-id="element-94" data-mp="1274mfkm8f854" />
      <span aria-hidden="true" className="pointer-events-none absolute -bottom-20 -left-12 hidden h-40 w-40 rounded-full bg-coral/15 xl:block" data-id="element-95" data-mp="sai3509k0p57" />
      <span aria-hidden="true" className="pointer-events-none absolute left-10 top-1/2 hidden h-6 w-6 rotate-12 rounded-md bg-violet/60 xl:block" data-id="element-96" data-mp="neawf59c39m7" />

      <div className="relative mx-auto grid max-w-page gap-6 px-5 pb-10 pt-6 md:px-8 md:pb-16 md:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-x-12 lg:gap-y-8" data-id="element-97" data-mp="3825zatgqudmy">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-98" data-mp="3j6obvk13emq3">
          <p className="mb-3 font-display text-[11px] font-extrabold tracking-[0.12em] text-coral-ink sm:text-[12px] sm:tracking-[0.14em]" data-id="element-99" data-mp="3o73na61tdk5f">{hero.eyebrow}</p>
          <h1 id="hero-title" className="font-display text-[2.15rem] font-black uppercase leading-[1.05] tracking-tight text-ink sm:text-[2.7rem] lg:text-[3.35rem]" data-id="element-100" data-mp="3e963buqzm9im">
            {hero.titleLead} <span className="marker text-brand" data-id="element-101" data-mp="358ztqjyettoq">{hero.titleHighlight}</span>
          </h1>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/80 md:text-[19px]" data-id="element-102" data-mp="2qkda461r2frp">{hero.sub}</p>
        </div>

        <div className="mx-auto aspect-[4/3] w-full max-w-[400px] sm:max-w-[500px] lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-w-none lg:self-center" data-id="element-103" data-mp="2vjzqgocvkc4q">
          <ImageSlot url={heroMockupUrl} alt={hero.mockupAlt} slotName="heroMockupUrl" fit="contain" eager data-id="element-104" data-mp="2lkqyg11kl7l0" />
        </div>

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-105" data-mp="s2joo1a4k8lm">
          <CtaButton microcopy={ctaMicrocopy} data-id="element-106" data-mp="s3undmopqq5v" />
        </div>
      </div>
    </section>;
}